import { doGet } from './common';

const getOrderCountByYear = (id, type) => {
  if (id) {
    return doGet(`/api/bi/order/${type}/year/${id}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
  }
  return doGet(`/api/bi/order/${type}/year`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getOrderCountByYearMonth = (id, type) => {
  console.log('type:', type)
  if (id) {
    return doGet(`/api/bi/order/${type}/month/${id}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
  }
  return doGet(`/api/bi/order/${type}/month`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const getOrderCountByYearQuarter = (id, type) => {
  if (id) {
    return doGet(`/api/bi/order/${type}/quarter/${id}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
  }
  return doGet(`/api/bi/order/${type}/quarter`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}


const getOrderPending = (id) => {
  return doGet(`/api/stat/order/pending`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getOrderCompleted = (id) => {
  return doGet(`/api/stat/order/completed`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

export {
  getOrderPending,
  getOrderCompleted,
  getOrderCountByYear,
  getOrderCountByYearMonth,
  getOrderCountByYearQuarter
}